import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var TestPipe = (function () {
    function TestPipe() {
    }
    TestPipe.prototype.transform = function (text, pattern, flags) {
        if (!isString(text)) {
            return text;
        }
        return (new RegExp(pattern, flags)).test(text);
    };
    return TestPipe;
}());
export { TestPipe };
TestPipe.decorators = [
    { type: Pipe, args: [{ name: 'test' },] },
];
/** @nocollapse */
TestPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=test.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/test.js
// module id = 269
// module chunks = 4